import { Navigate, useRoutes } from 'react-router-dom';
// config
// import { PATH_AFTER_LOGIN } from 'src/config-global';
//
import { mainRoutes } from './main';
import { studentRoutes } from './student';

import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';

import { useAuthContext } from 'src/auth/hooks/use-auth-context';
import { paths, PATH_DASHBOARD } from 'src/routes/paths';

// ----------------------------------------------------------------------

export default function Router() {
  const { isAuthenticated } = useAuthContext();

  return useRoutes([
    {
      path: '/',
      element: <Navigate to={isAuthenticated ? PATH_DASHBOARD.companies.root : paths.auth.jwt.login} replace />,
    },

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Student routes
    ...studentRoutes,

    // Main routes
    ...mainRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
